import api from "./api";

export const getMessageTemplates = async (params: Record<string, any> = {}) => {
  const { data } = await api.get("/messageTemplates", { params });

  return data.messageTemplates;
};
